


import upload from './components/Upload.vue';
import helloWorld from './components/HelloWorld.vue';
import PDFDrop from './components/PDFDrop.vue';
import Pricing from './components/Pricing.vue';
import Signup from './components/Signup.vue';
import Contact from './components/Contact.vue';

// 2. Define some routes
// Each route should map to a component. The "component" can
// either be an actual component constructor created via
// `Vue.extend()`, or just a component options object.
// We'll talk about nested routes later.
const routes = [
  //{ path: '/:faxNumber', name: 'upload', component: upload, props: true},
  { path: '/', name: 'hello', component: helloWorld},
  { path: '/pdfdrop', name: 'pdfdrop', component: PDFDrop},
  { path: '/pricing', name: 'pricing', component: Pricing},
  { path: '/contact', name: 'contact', component: Contact},
  { path: '/signup/:product', name: 'signup', component: Signup, props: true},
  { path: '/:faxNumber(\\d{10})', name: 'upload', component: upload, props: true},
  { path: '/:faxNumber(\\d{3}-\\d{3}-\\d{4})', name: 'upload-avec-hyphans', component: upload, props: true},

]

export {routes};